export default __webpack_public_path__ + "static/unknown-icon-4837be541deb3b402f0dce10ec869ed9.png";